// const projectDomainData = [
//   {
//     title: 'Web Development',
//     description: `We build high-performance, responsive, and scalable web applications tailored to your business needs. From intuitive UI/UX to robust backend architecture, our full-stack expertise ensures a seamless digital experience for your users.`,
//     services: [
//       'Frontend Development (React, Next.js)',
//       'Backend Development (Node.js, FastAPI)',
//       'Full Stack Development',
//       'Responsive UI/UX Design',
//       'Web App Deployment & Hosting',
//       'SEO Optimization',
//       'Progressive Web Apps (PWA)',
//     ],
//     icon: 'AiOutlineGlobal',
//     // icon: 'FaCogs',
//     // color: '#fd9a00'
//     color: '#156'
//   },  
//   {
//     title: 'AI & ML',
//     description: `Embrace AI & ML to drive innovation and efficiency in your business. Our customized solutions offer advanced insights and automation, enabling streamlined processes, data-driven decisions, and a competitive edge in the evolving tech world.`,
//     services: [
//       'AI Development',
//       'AI Chatbot Development',
//       'ML Development',
//       'Large Language Model',
//       'RPA Development',
//       'Generative AI',
//       'AI Consulting'
//     ],
//     icon: 'FaBrain',
//     color: '#156'
//   },
//   {
//     title: 'Data Engineering',
//     description: `Transform your data into actionable insights with our advanced data engineering services.`,
//     services: [
//       'Data Pipeline Design',
//       'ETL/ELT Development',
//       'Real-time Data Processing',
//       'Data Lake Solutions',
//       'Big Data Architecture'
//     ],
//     icon: 'FaDatabase',
//     // color: '#62a2e4'
//     color: '#156'
//   },
//   {
//     title: 'Automation & RPA',
//     description: `Improve efficiency and reduce manual efforts by automating repetitive tasks.`,
//     services: [
//       'Robotic Process Automation',
//       'Workflow Automation',
//       'Scripted Task Management',
//       'No-code Automation Platforms'
//     ],
//     icon: 'FaCogs',
//     color: '#156'
//   }
//   // Add more domains as needed
// ];




const projectDomainData = [
  {
    title: 'Web Development',
    description: `We create dynamic, secure, and scalable web applications designed to elevate your digital presence. Our team blends clean code with sleek design to deliver smooth, high-performing experiences that keep users engaged and businesses growing.`,
    services: [
      'Frontend Development (React, Next.js)',
      'Backend Development (Node.js, FastAPI)',
      'Full Stack Development',
      'Responsive UI/UX Implementation',
      'Web App Deployment & Hosting',
      'SEO Optimization',
      'Progressive Web Apps (PWA)'
    ],
    icon: 'AiOutlineGlobal',
    color: '#156'
  },
  {
    title: 'Mobile App Development',
    description: `From concept to launch, we build mobile applications that are intuitive, feature-rich, and optimized for performance. Whether it’s native or cross-platform, we craft apps that deliver seamless experiences across devices.`,
    services: [
      'iOS & Android App Development',
      'React Native & Flutter Solutions',
      'App UI/UX Design',
      'App Store & Play Store Deployment',
      'Mobile API Integration',
      'Maintenance & Version Upgrades'
    ],
    icon: 'FaMobileAlt',
    color: '#156'
  },
  // {
  //   title: 'Cloud Solutions',
  //   description: `Unlock the full potential of your business with secure, scalable, and efficient cloud infrastructure. We help you modernize operations through smart cloud architecture, migration, and management services.`,
  //   services: [
  //     'Cloud Migration (AWS, Azure, GCP)',
  //     'Serverless Architecture',
  //     'Cloud-Native Application Development',
  //     'Performance & Cost Optimization',
  //     'Cloud Security & Compliance',
  //     'Monitoring & Infrastructure Management'
  //   ],
  //   icon: 'FaCloud',
  //   color: '#156'
  // },
  {
    title: 'AI & ML',
    description: `Harness the power of artificial intelligence and machine learning to automate, analyze, and innovate. We design AI-driven systems that transform data into insights and ideas into intelligent products.`,
    services: [
      'AI Solution Development',
      'Chatbot & Virtual Assistant Design',
      'Machine Learning Models',
      'Large Language Model Integration',
      'Generative AI Systems',
      'RPA Implementation',
      'AI Strategy Consulting'
    ],
    icon: 'FaBrain',
    color: '#156'
  },
  {
    title: 'Data Engineering',
    description: `We build strong data foundations that empower smarter decisions. Our engineering solutions ensure your data is clean, connected, and ready to fuel advanced analytics and business intelligence.`,
    services: [
      'Data Pipeline Architecture',
      'ETL/ELT Design & Implementation',
      'Real-time Data Streaming',
      'Data Lake & Warehouse Development',
      'Big Data Processing',
      'Data Governance & Quality Management'
    ],
    icon: 'FaDatabase',
    color: '#156'
  },
  {
    title: 'DevOps & Infrastructure',
    description: `Speed up delivery without sacrificing quality. We bring automation, collaboration, and reliability to your development lifecycle through DevOps best practices and modern infrastructure management.`,
    services: [
      'CI/CD Pipeline Setup',
      'Containerization (Docker, Kubernetes)',
      'Infrastructure as Code (Terraform, Ansible)',
      'Continuous Monitoring & Logging',
      'Cloud Infrastructure Automation',
      'Release Management'
    ],
    icon: 'FaTools',
    color: '#156'
  },
  {
    title: 'Automation & RPA',
    description: `Save time, reduce errors, and scale efficiency with intelligent automation. We design and deploy robotic process automation systems that free your team from repetitive, manual tasks.`,
    services: [
      'Robotic Process Automation (RPA)',
      'Workflow & Task Automation',
      'No-Code/Low-Code Automation Platforms',
      'Process Mapping & Optimization',
      'Custom Scripted Solutions'
    ],
    icon: 'FaCogs',
    color: '#156'
  },
  // {
  //   title: 'Cybersecurity',
  //   description: `Your data deserves the highest level of protection. We help safeguard your digital ecosystem through proactive threat detection, risk mitigation, and end-to-end security strategies.`,
  //   services: [
  //     'Vulnerability Assessment & Penetration Testing',
  //     'Network & Cloud Security',
  //     'Endpoint Protection & Monitoring',
  //     'Security Architecture Design',
  //     'Compliance Audits (ISO, SOC2, GDPR)',
  //     'Incident Detection & Response'
  //   ],
  //   icon: 'FaShieldAlt',
  //   color: '#156'
  // },
  // {
  //   title: 'Blockchain Solutions',
  //   description: `Build transparent, secure, and decentralized applications powered by blockchain technology. We help businesses adopt blockchain for smarter contracts, data integrity, and digital trust.`,
  //   services: [
  //     'Smart Contract Development',
  //     'DApp (Decentralized App) Development',
  //     'Private & Public Blockchain Integration',
  //     'NFT & Tokenization Platforms',
  //     'Blockchain Strategy & Consulting'
  //   ],
  //   icon: 'FaLink',
  //   color: '#156'
  // },
  // {
  //   title: 'Internet of Things (IoT)',
  //   description: `Connect the digital and physical worlds with IoT solutions that gather, analyze, and act on real-time data. We design end-to-end systems for automation, analytics, and smarter business operations.`,
  //   services: [
  //     'IoT Device Connectivity & Integration',
  //     'IoT Platform Development',
  //     'Edge & Sensor Data Processing',
  //     'Predictive Maintenance Solutions',
  //     'IoT Security & Management'
  //   ],
  //   icon: 'FaNetworkWired',
  //   color: '#156'
  // },
  {
    title: 'UI/UX & Product Design',
    description: `Design is how your users experience your product. We craft clean, intuitive interfaces that align with your brand and keep your customers coming back.`,
    services: [
      'User Research & Journey Mapping',
      'Wireframing & Prototyping',
      'High-Fidelity UI Design',
      'Design System Development',
      'Usability Testing & Iteration'
    ],
    icon: 'FaPencilRuler',
    color: '#156'
  },
  {
    title: 'IT Consulting & Strategy',
    description: `Technology should work for your goals, not against them. We guide businesses in choosing the right tools, processes, and architectures to stay future-ready and competitive.`,
    services: [
      'Digital Transformation Strategy',
      'Technology Roadmapping',
      'Cloud & Infrastructure Consulting',
      'Software Architecture Review',
      'Enterprise IT Assessment',
      'Project & Delivery Management'
    ],
    icon: 'FaChartLine',
    color: '#156'
  }
];

module.exports = {projectDomainData}
  